import React from 'react';
import PropTypes from 'prop-types';
import { ModalShell } from '../modalsShared';

export const CancelRequestModal = ({
  isOpen,
  requestNumber,
  isSubmitting = false,
  isConfirmDisabled = false,
  onClose,
  onConfirm,
}) => {
  if (!isOpen) return null;

  return (
    <ModalShell
      isOpen={isOpen}
      onClose={onClose}
      title="Cancel request"
      size="small"
      modalClassName="request-history-submodal"
    >
      <div className="request-history-confirmation-text">
        {`Are you sure you want to cancel the request ${requestNumber || '-'}`}
      </div>
      <div className="modal-actions">
        <button type="button" className="btn-cancel" onClick={onClose} disabled={isSubmitting}>
          No
        </button>
        <button
          type="button"
          className="btn-primary"
          onClick={onConfirm}
          disabled={isSubmitting || isConfirmDisabled}
        >
          Yes
        </button>
      </div>
    </ModalShell>
  );
};

CancelRequestModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  requestNumber: PropTypes.string,
  isSubmitting: PropTypes.bool,
  isConfirmDisabled: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};
